export const TIPO_CONTRATO_AS = {
  COMISSIONAMENTO: 'Contrato de comissionamento',
  ISENCAO_COM_REPASSE: 'Isenção de comissionamento com repasse',
  ISENCAO: 'Isenção de comissionamento',
};

export const CAMPOS_OBRIGATORIOS_AS = [
  {
    name: 'telefone',
    label: 'Telefone Celular',
    getValor: (controls) => {
      if (!Array.isArray(controls?.telefones)) return '';
      const tel = controls.telefones.find(t => String(t?.numero?.value || '').trim().length > 0);
      return tel ? String(tel.numero.value) : '';
    },
  },
  {
    name: 'email',
    label: 'E-mail',
    getValor: (controls) => {
      if (!Array.isArray(controls?.emails)) return '';
      const em = controls.emails.find(e => String(e?.email?.value || '').trim().length > 0);
      return em ? String(em.email.value) : '';
    },
  },
  {
    name: 'cep',
    label: 'CEP',
    getValor: controls => String(controls?.endereco?.cep?.value || '').trim(),
  },
  {
    name: 'cidade',
    label: 'Cidade',
    getValor: controls => String(controls?.endereco?.cidade?.value || '').trim(),
  },
  {
    name: 'estado',
    label: 'Estado',
    getValor: controls => String(controls?.endereco?.estado?.value || '').trim(),
  },
  {
    name: 'bairro',
    label: 'Bairro',
    getValor: controls => String(controls?.endereco?.bairro?.value || '').trim(),
  },
  {
    name: 'logradouro',
    label: 'Endereço',
    getValor: controls => String(controls?.endereco?.endereco?.value || '').trim(),
  },
  {
    name: 'numero',
    label: 'Número',
    getValor: controls => String(controls?.endereco?.numero?.value || '').trim(),
  },
  {
    name: 'nome',
    label: 'Nome',
    getValor: controls => String(controls?.nome?.value || '').trim(),
  },
  {
    name: 'documento',
    label: 'Documento',
    getValor: controls => String(controls?.documento?.value || '').trim(),
  },
  {
    name: 'nomeFantasia',
    label: 'Nome Fantasia',
    getValor: controls => String(controls?.nomeFantasia?.value || '').trim(),
  },
];

export function getCamposIncompletosAS(controls) {
  return CAMPOS_OBRIGATORIOS_AS
    .filter(campo => !campo.getValor(controls))
    .map(({ name, label }) => ({ name, label }));
}

export function isPermiteAcordoSeguro(idTipoAcordoSeguro, tiposSelector) {
  if (!Array.isArray(tiposSelector) || tiposSelector.length === 0) return false;
  const tipo = tiposSelector.find(t => t.id === idTipoAcordoSeguro);
  if (!tipo || !tipo.value) return false;
  return !String(tipo.value).toLowerCase().includes('não permite');
}

export function getNaoPermiteIdAS(tiposSelector) {
  if (!Array.isArray(tiposSelector)) return null;
  const naoPermite = tiposSelector.find(t => String(t.value || '').toLowerCase().includes('não permite'));
  return naoPermite ? naoPermite.id : null;
}
